export default "__VITE_ASSET__DOoKH2kt__"